import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const InstanceSubPatch = ({instance}) => { 
    if (!instance) {
        return 'empty';
    }
    let implementing = instance.implements;
    if (!implementing) {
        return 'not found';
    }
    let number = implementing.instances.indexOf(instance) + 1;
    let name = implementing.zObject.args[0];

    let numberOfIO = Math.max(implementing.inletObjects.length, implementing.outletObjects.length);
    let style = {};
    style.minWidth = numberOfIO * 26 + 'px';
    style.width = Math.max(120, numberOfIO * 26) + 'px';
    return (<div style={style} className="instance-sub-patch"><span className="implement-name">{name}</span> instance #{number}</div>);
};

const mapStateToProps = (state, props) => {
  return {
      implements: props.instance && props.instance.implements
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InstanceSubPatch);
